import { gql } from "apollo-boost";

export const GET_VALET_ADDON_PRICE = gql`
  query consumerValetAddonPrice($branchId : String, $startLat: String, $startLong: String, $endLat: String, $endLong: String) {
    consumerValetAddonPrice(branchId: $branchId, startLat: $startLat, startLong: $startLong, endLat: $endLat, endLong: $endLong)
  }
`;


